import PropTypes from 'prop-types';
import {
  useEffect,
  useMemo,
  useRef
} from 'react';

import { JsonEditor as Editor } from 'jsoneditor-react';
import 'jsoneditor-react/es/editor.min.css';

export function JSONViewer({
  json = {},
  mode = Editor.modes.view,
  allowedModes = Editor.modes.allValues,
  ...props
}) {
  const editorRef = useRef();

  const src = useMemo(() => {
    if (typeof json === 'string') {
      return json;
    }
    if (typeof json === 'object') {
      return json;
    }
    return JSON.parse(json);
  }, [json]);

  useEffect(() => {
    if (mode === Editor.modes.view || mode === Editor.modes.form || mode === Editor.modes.tree) {
      editorRef.current.expandAll();
    }
  }, [src, mode]);

  return (
    <Editor
      ref={editorRef}
      value={src}
      allowedModes={allowedModes}
      mode={mode}
      {...props}
    />
  );
}

JSONViewer.propTypes = {
  json: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array
  ]).isRequired,
  allowedModes: PropTypes.arrayOf(PropTypes.string),
  mode: PropTypes.string
};

export default JSONViewer;
